var _style, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs, _g5, _path20, _path21, _defs2, _g6, _path22, _path23, _path24, _path25, _path26, _path27, _defs3, _g7, _path28, _path29, _path30, _path31, _defs4, _g8, _path32, _path33, _path34, _path35, _defs5, _g9, _path36, _path37, _circle, _circle2, _g0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError401(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0DB14B;}\r\n\t.st1{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st2{fill:#263238;stroke:#263238;stroke-width:1.193;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st3{fill:#FFFFFF;stroke:#263238;stroke-width:1.193;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:1.193;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st5{fill:none;stroke:#263238;stroke-width:1.193;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st6{fill:#263238;}\r\n\t.st7{fill:#0DB14B;stroke:#263238;stroke-width:1.193;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st8{fill:#757575;stroke:#263238;stroke-width:1.193;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st9{clip-path:url(#SVGID_2_);}\r\n\t.st10{opacity:0.18;enable-background:new    ;}\r\n\t.st11{fill:#FFFFFF;}\r\n\t.st12{clip-path:url(#SVGID_4_);}\r\n\t.st13{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st14{clip-path:url(#SVGID_6_);}\r\n\t.st15{opacity:0.3;enable-background:new    ;}\r\n\t.st16{fill:#757575;}\r\n\t.st17{clip-path:url(#SVGID_8_);}\r\n\t.st18{clip-path:url(#SVGID_10_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.3,258.1c0,0,2.3,73,63.3,121.6s145.3,52.1,213.6,56.7S442,402.4,450,344s-44.3-75.6-72.6-142.2 s-25.8-88.4-85.8-129.4S137.9,56.6,88.7,126.7S44.3,258.1,44.3,258.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.3,258.1c0,0,2.3,73,63.3,121.6s145.3,52.1,213.6,56.7S442,402.4,450,344s-44.3-75.6-72.6-142.2 s-25.8-88.4-85.8-129.4S137.9,56.6,88.7,126.7S44.3,258.1,44.3,258.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hole--inject-64"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 341.5,
    cy: 385.8,
    rx: 72.2,
    ry: 21.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M341.5,374.2c34.1,0,62.8,7,70.3,16.5c1.2-1.4,1.9-3.1,1.9-4.9c0-11.8-32.3-21.4-72.2-21.4 s-72.2,9.6-72.2,21.4c0.1,1.8,0.8,3.5,1.9,4.9C278.7,381.3,307.3,374.2,341.5,374.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M331.6,404.5c-24.1-1.1-42.3-6-42.3-12c0-0.7,0.2-1.3,0.6-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M387.6,386.7c4.1,1.8,6.5,3.8,6.5,5.9c0,6.7-23.5,12.2-52.4,12.2h-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M296.4,386.5c9.1-3.6,26-6.1,45.3-6.1c11-0.1,22,0.8,32.8,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M330.9,396.7c-6.1-0.9-10.2-2.4-10.2-4.2c0-2.7,9.4-4.9,21-4.9s21,2.2,21,4.9c0,2.3-6.9,4.2-16.2,4.7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Landscape--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M51.5,299.7c31.5-9,97.8-26.6,134.3-27.9c49.2-1.7,132.2,33.9,184,40.2s86.6,4.5,86.6,4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M34,304.8c0,0,2.7-0.8,7.5-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M442.5,249.1c-18.2-4-36.7-5.7-55.3-5.2c-38.4,1.3-80,6.4-131.4,13c-51.4,6.6-124.6-30-174.4-16.4 s-46,17.7-46,17.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M456.6,252.8c0,0-1.9-0.6-5.5-1.6"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M364.5,158.4c-1.4-5.6-7-8.9-12.5-7.6c-3.7,0.9-6.7,3.8-7.6,7.6H364.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M466,158.4c-1.2-5.2-5.6-9.2-11-9.8c3.1-16.3-7.6-32-23.9-35.1c-1.9-0.4-3.8-0.5-5.7-0.5 c-14.6,0-27,10.4-29.6,24.8c-8.4-6.5-20.4-5.1-27,3.3c-2.6,3.4-4.1,7.6-4.1,11.9c0,1.8,0.3,3.7,0.8,5.4L466,158.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M185.6,182.5c-0.7-2.8-3.5-4.6-6.3-3.9c-1.9,0.5-3.4,2-3.9,3.9H185.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M237.1,182.5c-0.6-2.7-2.9-4.7-5.6-5c2-8.2-3.1-16.4-11.3-18.4s-16.4,3.1-18.4,11.3c-0.1,0.5-0.2,1.1-0.3,1.6 c-4.2-3.3-10.4-2.6-13.7,1.7c-1.3,1.7-2.1,3.8-2.1,6c0,0.9,0.1,1.9,0.4,2.8L237.1,182.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M231.9,198.6c-0.4-1.8-2.2-2.9-4-2.5c-1.2,0.3-2.2,1.2-2.5,2.5H231.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M264.5,198.6c-0.4-1.7-1.8-2.9-3.5-3.1c0.1-0.6,0.2-1.2,0.2-1.8c-0.1-5.3-4.4-9.6-9.8-9.5 c-4.6,0.1-8.5,3.3-9.3,7.8c-2.7-2.1-6.6-1.6-8.6,1.1c-0.8,1.1-1.3,2.4-1.3,3.8c0,0.6,0.1,1.2,0.3,1.7H264.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-64"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M162.6,313.8c-0.4,0-0.7-0.1-1-0.3c-0.9-0.6-1.2-1.7-0.7-2.7c0.5-0.9,124.1-135.7,180.7-185.1 c0.4-0.3,1-0.3,1.4,0.1c0.3,0.4,0.3,1-0.1,1.4C286.6,176.5,164.8,312,164.3,312.9C164,313.5,163.3,313.8,162.6,313.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M169.5,287c0,0,6.1-6.5,9.8-6.5s10.6,6.1,10.2,9.4s-6.5,0.4-6.5,0.4s-5.7,7.8-11.4,6.5S169.5,287,169.5,287z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M183,290.3c0,0,3.8,2.6,4.1,4.4s-4.2,7-9.1,8.2s-7.7-1.7-6.2-4.3S179.2,290.5,183,290.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M337,266.6V131.3c0,0-2.7,9.8-2.7,10.5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 289.7,
    y: 273.7,
    className: "st7",
    width: 103.7,
    height: 83.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M338.5,273.3v-4.8c0-0.7-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2v4.8H338.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M348,261.8v0.2c-0.2-0.4-0.6-0.6-1-0.6c-0.7,0-1.2,0.5-1.2,1.2l0,0v12.7c0,2-1.6,3.7-3.7,3.7 c-0.5,0-1-0.1-1.5-0.3c-0.5,0.8-0.4,1.9,0.3,2.6c0.4,0.1,0.8,0.1,1.2,0.1c3.3,0,6-2.7,6-6v-5.9h2.7L348,261.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M337.1,130c0,0,2.1-7.5,0.2-6.8S337.1,130,337.1,130z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M337.1,130c0,0-8-2.8-7.3-0.2S337.1,130,337.1,130z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164.6,195.6c0,0-9.9-5.5-29.2-2.8s-23.1,18.7-19.9,35.3s21.5,30.6,24.2,29.5s-0.8-38.3,5.5-45.4 s26.9-5.9,28-11.4S164.6,195.6,164.6,195.6z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M130.2,205.5l2,13.1c0,0-12.4,33.9-10.4,38.5s20.8,6.4,20.8,6.4s30.5,3.7,39.6,0s4.4-14.4,3.4-17.4 s-6.7-27.1-6.7-27.1s2-5.7,2-8.7s-0.3-11.4-1.7-13.4s-24.8-4.4-35.2-2.7S128.8,198.4,130.2,205.5z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M135.6,220.6c0,0-0.3,29.1,1.3,34.9s8.4,12.4,22.4,10.7s15.4-15.1,15.4-15.1l-1-31.2L135.6,220.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M161.8,249.1c0,2.3-1.9,4.1-4.1,4.1c-2.3,0-4.1-1.9-4.1-4.1c0-2.3,1.9-4.1,4.1-4.1l0,0 C160,244.9,161.8,246.8,161.8,249.1L161.8,249.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M142.1,226.8c1.5-2.3,4.4-3.3,7-2.6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.3,224.6c0,0,4.8-1.5,6.3,2.6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M178.4,411.6c0,0,5.3-3.2,8.2-4.4c0.3-0.1,0.6-0.2,0.8-0.3c2.6-0.9,9.9-0.4,16.8-4.7s3.4-9.5-1.7-10.8 s-10.7-3-10.7-3l-1.3-20.2c0,0-15.5,4.3-20.6,6.5s-2.1,32.7-1.7,35.3S168.6,414.2,178.4,411.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M195.6,402.2c-9,1.7-9,3.4-18.9,5.2c-2.9,0.6-5.9,0.8-8.8,0.7c0.1,0.9,0.2,1.6,0.2,1.9 c0.4,2.6,0.4,4.3,10.3,1.7c0,0,5.3-3.2,8.2-4.4c0.3-0.1,0.6-0.2,0.8-0.3c2.6-0.9,9.9-0.4,16.8-4.7c2.2-1.4,3.3-2.8,3.7-4.2 C204,399.8,199.9,401.3,195.6,402.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M199.2,391.1c0,0-0.3,23.5-1,28.5s0.3,11.4,8,11.4s22.8-5,28.1-6s14.1-3.4,17.8-11.7s-18.8-7.4-18.8-7.4 l1.3-17.1C234.7,388.8,211.6,393.5,199.2,391.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M252.2,413.3c0.4-0.8,0.5-1.7,0.3-2.6c-2.3,3.1-5.4,5.5-9,7c-8,3.4-23.1,7-34.5,8.7c-5.2,0.8-8.5-0.1-10.6-1.2 c0.7,3.3,2.9,5.9,7.9,5.9c7.7,0,22.8-5,28.1-6S248.5,421.6,252.2,413.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M233.4,405.9c0,0,1.7,5.7-3,9.4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M196.9,378.8c0,0-0.5,10.2,0.1,12.2c2.1,7.7,2.8,5.9,18.9,5.6s22.6-6.8,24.3-10.8s0-12.7-0.7-15.8 s-6-4-8.1-3.7S197.9,375.4,196.9,378.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.3,404.2v22.5c0,1.8,1,3.4,2.6,4.3l36.2,18.7c1.3,0.7,2.8,0.7,4.2,0.1l53.3-20.3c1.7-0.8,2.9-2.5,2.9-4.4 v-27.2l-61,18.4L86.3,404.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M86.3,404.2v22.5c0,1.8,1,3.4,2.6,4.3l36.2,18.7c1.3,0.7,2.8,0.7,4.2,0.1l53.3-20.3 c1.7-0.8,2.9-2.5,2.9-4.4v-27.2l-61,18.4L86.3,404.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M127.2,415.5l-2.7,0.8l-38.2-12.1v22.5c0,1.8,1,3.4,2.6,4.3l36.2,18.7c0.6,0.3,1.3,0.5,2.1,0.5 L127.2,415.5z"
  }))))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M86.3,404.2v22.5c0,1.8,1,3.4,2.6,4.3l36.2,18.7c1.3,0.7,2.8,0.7,4.2,0.1l53.3-20.3c1.7-0.8,2.9-2.5,2.9-4.4 v-27.2l-61,18.4L86.3,404.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M142,366.2L83.5,385c-0.9,0.3-1.6,1.2-1.6,2.2v16.7c0,0.9,0.5,1.6,1.3,2l40.8,19.4c0.6,0.3,1.2,0.3,1.8,0.1 l61.2-22.9c0.9-0.3,1.5-1.2,1.5-2.1l0.1-15.6c0-1.1-0.7-2-1.8-2.2l-43.6-16.3C142.8,366.1,142.4,366.1,142,366.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M142,366.2L83.5,385c-0.9,0.3-1.6,1.2-1.6,2.2v16.7c0,0.9,0.5,1.6,1.3,2l40.8,19.4 c0.6,0.3,1.2,0.3,1.8,0.1l61.2-22.9c0.9-0.3,1.5-1.2,1.5-2.1l0.1-15.6c0-1.1-0.7-2-1.8-2.2l-43.6-16.3 C142.8,366.1,142.4,366.1,142,366.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.9,425.2L123.9,425.2c0.6,0.3,1.2,0.3,1.8,0.1l61.3-22.9c0.9-0.3,1.5-1.2,1.5-2.1l0.1-15.6 c0-0.5-0.2-1-0.5-1.5l-63.3,23.4L123.9,425.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M123.9,425.2L123.9,425.2c0.6,0.3,1.2,0.3,1.8,0.1l61.3-22.9c0.9-0.3,1.5-1.2,1.5-2.1l0.1-15.6 c0-0.5-0.2-1-0.5-1.5l-63.3,23.4L123.9,425.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.9,387.1v16.7c0,0.9,0.5,1.6,1.3,2l40.8,19.5c0.3,0.1,0.6,0.2,0.9,0.2v-18.9L82,386.7 C82,386.8,81.9,387,81.9,387.1z"
  }))))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M142,366.2L83.5,385c-0.9,0.3-1.6,1.2-1.6,2.2v16.7c0,0.9,0.5,1.6,1.3,2l40.8,19.4c0.6,0.3,1.2,0.3,1.8,0.1 l61.2-22.9c0.9-0.3,1.5-1.2,1.5-2.1l0.1-15.6c0-1.1-0.7-2-1.8-2.2l-43.6-16.3C142.8,366.1,142.4,366.1,142,366.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M222.4,335.5c0,0,7.7,3.7,11.7,11.1s1,21.4-1.4,25.8s-18.1,6.4-23.4,6.4s-6.4-0.7-6.4-0.7s-17.1,3.4-27.8,5.4 s-8-23.1-4.7-34.5s22.1-17.1,29.8-17.1S222.4,335.5,222.4,335.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M202.9,378.1c0,0,14.4-5,20.4-17.8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M216.6,370.7c4.6-1.9,8.9-4.8,12.4-8.4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M182.8,346.6c0,0,4,21.1,2,29.8s-13.7,10.1-16.4,9s-1.3-21.8-1.3-32.2S177.4,343.6,182.8,346.6z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.3,290.3c0,0-2.3,13.7-0.7,20.5c0.9,3.7,2.4,7.3,4.7,10.4c0,0-8.4,12.4-6.7,22.8s6,11.7,6,11.7 s-3.7,19.1,3,25.8s21.4,14.1,37.9,11.1s27.5-3.7,30.8-9.4s1.3-30.8,1.3-30.8s-0.7-27.8-1.3-44.9s-3-30.8-11.1-37.5 s-43.6,3.7-54.3,10.7S97.3,290.3,97.3,290.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M97.3,290.3c0,0-2.3,13.7-0.7,20.5c0.9,3.7,2.4,7.3,4.7,10.4c0,0-8.4,12.4-6.7,22.8s6,11.7,6,11.7 s-3.7,19.1,3,25.8s21.4,14.1,37.9,11.1s27.5-3.7,30.8-9.4s1.3-30.8,1.3-30.8s-0.7-27.8-1.3-44.9s-3-30.8-11.1-37.5 s-43.6,3.7-54.3,10.7S97.3,290.3,97.3,290.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M99.7,290.3c0,0-2.3,13.7-0.7,20.5c0.8,3.7,2.4,7.3,4.7,10.4c0,0-8.4,12.4-6.7,22.8s6,11.7,6,11.7 s-3.7,19.1,3,25.8s21.5,14.1,37.9,11.1s27.5-3.7,30.8-9.4s1.3-30.8,1.3-30.8s-0.7-27.8-1.3-44.9s-3-30.8-11.1-37.5 s-43.6,3.7-54.3,10.7S99.7,290.3,99.7,290.3z"
  }))))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M97.3,290.3c0,0-2.3,13.7-0.7,20.5c0.9,3.7,2.4,7.3,4.7,10.4c0,0-8.4,12.4-6.7,22.8s6,11.7,6,11.7 s-3.7,19.1,3,25.8s21.4,14.1,37.9,11.1s27.5-3.7,30.8-9.4s1.3-30.8,1.3-30.8s-0.7-27.8-1.3-44.9s-3-30.8-11.1-37.5 s-43.6,3.7-54.3,10.7S97.3,290.3,97.3,290.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M101.4,321.1c10.5,7.2,23.8,9,35.9,5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M100.7,355.6c0,0,17.1,16.8,45.3,0.7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M167.4,273.9c0,0-6.4-9.7-15.1-15.1s-31.2-9.4-40.2-11.1s-18.8-1-21.5,9s-2.3,26.8,0.3,34.2 s13.7,11.7,22.5,6.7s32.8-24.5,41.2-25.5S166.7,277.5,167.4,273.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M167.4,273.9c0,0-6.4-9.7-15.1-15.1s-31.2-9.4-40.2-11.1s-18.8-1-21.5,9s-2.3,26.8,0.3,34.2 s13.7,11.7,22.5,6.7s32.8-24.5,41.2-25.5S166.7,277.5,167.4,273.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M148.8,272c5.1-2.1-7.7,1.7-8.5,0.4s8.9-7.7,11.1-8.5s-12.4,2.1-11.9,0s14.1-2.6,4.7-4.7s-40-7.7-46-9.8 c-0.5-0.1-0.9-0.4-1.3-0.6c-3.1,1.6-5.4,4.6-6.2,8c-2.7,10-2.3,26.8,0.3,34.2c2.3,6.4,11,10.5,19,8.2c3.7-3,7.1-6.9,12.9-10.6 C134.3,281.3,143.7,274.1,148.8,272z"
  }))))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M167.4,273.9c0,0-6.4-9.7-15.1-15.1s-31.2-9.4-40.2-11.1s-18.8-1-21.5,9s-2.3,26.8,0.3,34.2 s13.7,11.7,22.5,6.7s32.8-24.5,41.2-25.5S166.7,277.5,167.4,273.9z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M203.6,319.4c0,0,7.7,1,12.7,3s8.4,14.4,6.4,16.1s-6-0.3-6-0.3c-3.2,1.1-6.4,1.9-9.7,2.3 C202.9,340.9,198.6,321.8,203.6,319.4z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M178.1,318.4c0,0,1.3,0,8.7-3.4s13.4-3.4,18.1,4s6.7,16.4,4,21.8s-12.7,9-18.1,9s-6-7-6-7s-0.7-11.1-4-15.1 S176.8,319.4,178.1,318.4z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.3,273.9c7.4-2.7,16.8-1,20.1,8.4s6.4,36.9,6.4,36.9s8.4,1,11.7,4.7s5,13.1,4.4,17.8s-12.4,13.4-25.8,13.7 s-23.1-6-27.8-23.1s-2.8-43.2-2.8-43.2s1.7-7.7,4.3-9.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M153.3,273.9c7.4-2.7,16.8-1,20.1,8.4s6.4,36.9,6.4,36.9s8.4,1,11.7,4.7s5,13.1,4.4,17.8 s-12.4,13.4-25.8,13.7s-23.1-6-27.8-23.1s-2.8-43.2-2.8-43.2s1.7-7.7,4.3-9.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M195.9,341.5c0.7-4.7-1-14.1-4.4-17.8c-0.1-0.1-0.3-0.3-0.4-0.4c0.4,3,0.6,6,0.7,9.1 c0.7,19.7-26.8,16.4-32.4,2.1c-3-7.7-3.8-41.3-12.8-43.9c-5.2-1.5-6.9,2.6-7.5,6.3c-0.2,9.6,0.1,24.5,3.1,35.2 c4.7,17.1,14.4,23.5,27.8,23.1S195.2,346.2,195.9,341.5z"
  }))))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M153.3,273.9c7.4-2.7,16.8-1,20.1,8.4s6.4,36.9,6.4,36.9s8.4,1,11.7,4.7s5,13.1,4.4,17.8s-12.4,13.4-25.8,13.7 s-23.1-6-27.8-23.1s-2.8-43.2-2.8-43.2s1.7-7.7,4.3-9.4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M179.8,319.1c0,0,2.6,12.2-10.8,18.9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 148.1,
    cy: 231.8,
    r: 2.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 163.9,
    cy: 231.8,
    r: 2.8
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M306.7,321.8l13-31h7.4v31h4.7v7.4h-4.7v10.5h-7.4v-10.5h-13V321.8z M319.7,321.8v-15.3l-6.1,15.3H319.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M358,328.6c0,3.3-1.1,6-3.4,8.3c-2.3,2.3-5,3.4-8.2,3.4c-3.3,0-6-1.1-8.3-3.4c-2.3-2.3-3.4-5-3.4-8.3v-26.7 c0-3.3,1.1-6,3.4-8.3c2.3-2.3,5.1-3.4,8.3-3.4c3.3,0,6,1.1,8.3,3.4c2.3,2.3,3.4,5.1,3.4,8.3V328.6z M350.4,301.8 c0-1.2-0.4-2.2-1.3-3c-0.8-0.8-1.8-1.3-3-1.3s-2.2,0.4-3,1.3c-0.8,0.8-1.2,1.8-1.2,3v26.8c0,1.2,0.4,2.2,1.2,3 c0.8,0.8,1.8,1.3,3,1.3s2.2-0.4,3-1.3c0.8-0.8,1.3-1.8,1.3-3V301.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M367,339.8v-37.7h-6.3v-5.2c1.8-0.2,3.5-0.9,5.1-2s2.8-2.5,3.5-4.1h5.2v49H367z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError401);
export default __webpack_public_path__ + "static/media/error401.4d1c833ff24b6a7b2a7314c7cf6e14e3.svg";
export { ForwardRef as ReactComponent };